import WrenchSvg from '../../icons/v2/WrenchSvg';
import { type CSSProperties, theme } from '../../style';
import { AccountSyncCheck } from '../accounts/AccountSyncCheck';

import { Button } from './Button';
import { View } from './View';

type AccountStatusIndicatorProps = {
  status: string;
  accountId: string;
};

const AccountStatusIndicator: React.FC<AccountStatusIndicatorProps> = ({
  status,
  accountId,
}) => {
  const getStatusComponent = (status: string, accountId: string) => {
    let content;
    let title = 'OK';
    const dotComponent = (styles?: CSSProperties) => (
      <div
        style={{
          backgroundColor: theme.errorText,
          width: 8,
          height: 8,
          borderRadius: 4,
          ...styles,
        }}
      />
    );
    switch (status) {
      case 'OK':
        content = dotComponent({
          backgroundColor: theme.sidebarItemBackgroundPositive,
        });
        break;
      case 'ERROR':
        content = dotComponent();
        title = 'Account is not synced and cannot be fixed currently';
        break;
      case 'ERROR_REPAIRABLE':
        content = (
          <AccountSyncCheck
            renderButton={(setOpen, triggerRef) => (
              <Button
                ref={triggerRef}
                type="bare"
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  padding: '4px 8px',
                  borderRadius: 4,
                }}
                onClick={() => setOpen(true)}
              >
                <WrenchSvg fill={theme.warningText} />
              </Button>
            )}
            accountId={accountId}
          />
        );
        title =
          'Account is not synced, but can be fixed by clicking the button';
        break;
      default:
        content = <span>N/A</span>;
    }
    return (
      <View
        title={title}
        style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
      >
        {content}
      </View>
    );
  };
  return <>{getStatusComponent(status, accountId)}</>;
};
export default AccountStatusIndicator;
